import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { FIELDGLASS_SSO } from "../../../constants/externalUrls";
import { quickActionTilesMap } from "../tilesMap";

const FieldglassTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={FIELDGLASS_SSO}
                linkText={quickActionTilesMap[id].description}
                title={"Fieldglass SSO"}
            />
        </QuickActionTile>
    );
};

FieldglassTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default FieldglassTile;
